<button mat-button color="primary" [disabled]="!params.data.dataSent"
    (click)="params.data.dataSent && openLogDetailModal(params.data.dataSent)">
    <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis" [class.mat-primary]="params.data.dataSent"></mat-icon>
</button>